import React from 'react';
import { Building2 } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-indigo-100 via-white to-purple-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center pt-6 sm:pt-8">
            <div className="flex items-center space-x-2">
              <Building2 className="h-8 w-8 sm:h-10 sm:w-10 text-indigo-600 dark:text-indigo-400" />
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
                Equisuite
              </h1>
            </div>
          </div>
          <div className="mt-8 sm:mt-12 md:mt-16 mb-12 sm:mb-16">
            <div className="bg-white dark:bg-gray-800 w-full max-w-md mx-auto rounded-lg shadow-xl overflow-hidden">
              <div className="px-4 py-6 sm:px-8 sm:py-8">
                <ThemeToggle />
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
